
import React from 'react';
import { ChannelType } from '../types';
import { Zap, FileText, Mail, Printer, Send } from 'lucide-react';
import { COLORS } from '../constants/theme';

interface BrandLogoProps {
  type?: ChannelType | 'main';
  size?: number;
  className?: string;
}

export const BrandLogo: React.FC<BrandLogoProps> = ({ type = 'main', size = 40, className = '' }) => {
  const getLogoConfig = () => {
    switch (type) {
      case ChannelType.EDI:
        return { color: COLORS.channel.edi, icon: Zap, label: 'EDI' };
      case ChannelType.EBILL:
        return { color: COLORS.channel.ebill, icon: FileText, label: 'eB' };
      case ChannelType.EMAIL:
        return { color: '#2D5A27', icon: Mail, label: 'EM' }; // Darker green for contrast
      case ChannelType.PRINT:
        return { color: '#6A7328', icon: Printer, label: 'PR' }; // Olive for print
      case ChannelType.EPOST:
        return { color: '#4B5563', icon: Send, label: 'EP' }; // Slate for post
      case 'main':
      default:
        return { color: COLORS.brand.medium, icon: null, label: 'OS' };
    }
  };

  const { color, icon: Icon, label } = getLogoConfig();

  return (
    <div 
      className={`relative flex items-center justify-center shrink-0 ${className}`}
      style={{ width: size, height: size }}
    >
      <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="absolute inset-0">
        {/* Changed rx from 10 to 0 for sharp corners */}
        <rect width="40" height="40" rx="0" fill={color}/>
        {type === 'main' ? (
          <>
            <path d="M20 10C14.4772 10 10 14.4772 10 20C10 25.5228 14.4772 30 20 30C25.5228 30 30 25.5228 30 20C30 14.4772 25.5228 10 20 10ZM20 13C23.866 13 27 16.134 27 20C27 23.866 23.866 27 20 27C16.134 27 13 20C13 16.134 16.134 13 20 13Z" fill="white" fillOpacity="0.4"/>
            <circle cx="20" cy="20" r="4" fill="white"/>
          </>
        ) : null}
      </svg>
      {type !== 'main' && Icon && (
        <Icon size={size * 0.5} className="text-white relative z-10" strokeWidth={2} />
      )}
    </div>
  );
};
